var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "#FFF4EB",
    fillOpacity: 0.45,
    stroke: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.802 12.922C9.18933 12.922 9.523 12.8777 9.803 12.789C10.083 12.7003 10.3117 12.5767 10.489 12.418C10.671 12.2547 10.804 12.0633 10.888 11.844C10.972 11.62 11.014 11.375 11.014 11.109C11.014 10.591 10.8297 10.1827 10.461 9.884C10.0923 9.58067 9.53933 9.429 8.802 9.429H6.632V12.922H8.802ZM6.632 5.04V8.463H8.424C8.80667 8.463 9.138 8.421 9.418 8.337C9.70267 8.253 9.936 8.13633 10.118 7.987C10.3047 7.83767 10.4423 7.658 10.531 7.448C10.6197 7.23333 10.664 7 10.664 6.748C10.664 6.15533 10.4867 5.72367 10.132 5.453C9.77733 5.17767 9.22667 5.04 8.48 5.04H6.632ZM8.48 3.969C9.096 3.969 9.62567 4.02967 10.069 4.151C10.517 4.27233 10.8833 4.445 11.168 4.669C11.4573 4.893 11.6697 5.16833 11.805 5.495C11.9403 5.817 12.008 6.181 12.008 6.587C12.008 6.83433 11.9683 7.07233 11.889 7.301C11.8143 7.525 11.7 7.735 11.546 7.931C11.392 8.127 11.196 8.30433 10.958 8.463C10.7247 8.617 10.4493 8.743 10.132 8.841C10.8693 8.981 11.4223 9.24467 11.791 9.632C12.1643 10.0147 12.351 10.5187 12.351 11.144C12.351 11.5687 12.2717 11.956 12.113 12.306C11.959 12.656 11.7303 12.957 11.427 13.209C11.1283 13.461 10.7597 13.657 10.321 13.797C9.88233 13.9323 9.383 14 8.823 14H5.281V3.969H8.48Z",
    fill: "#F58120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessNameIcon);
export default __webpack_public_path__ + "static/media/BusinessNameIcon.0debd35fa7c8dd5a97fa94d2c1ee373f.svg";
export { ForwardRef as ReactComponent };